var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M6 1.00195C4.89543 1.00195 4 1.89738 4 3.00195V5.20703C4.32228 5.11588 4.65659 5.05337 5 5.02242V3.00195C5 2.44967 5.44771 2.00195 6 2.00195H8.99951V4.5029C8.99951 5.33133 9.67108 6.0029 10.4995 6.0029H13V12.998C13 13.5503 12.5523 13.998 12 13.998H9.74446C9.43145 14.3774 9.06858 14.7141 8.66586 14.998H12C13.1046 14.998 14 14.1026 14 12.998V5.41892C14 5.021 13.8419 4.63938 13.5605 4.35806L10.6424 1.4411C10.3611 1.15991 9.97969 1.00195 9.58196 1.00195H6ZM9.99951 4.5029V2.21237L12.7911 5.0029H10.4995C10.2234 5.0029 9.99951 4.77904 9.99951 4.5029Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M10 10.5C10 12.9853 7.98528 15 5.5 15C3.01472 15 1 12.9853 1 10.5C1 8.01472 3.01472 6 5.5 6C7.98528 6 10 8.01472 10 10.5ZM5.5 8C5.22386 8 5 8.22386 5 8.5V10.5C5 10.7761 5.22386 11 5.5 11C5.77614 11 6 10.7761 6 10.5V8.5C6 8.22386 5.77614 8 5.5 8ZM5.5 13.125C5.84518 13.125 6.125 12.8452 6.125 12.5C6.125 12.1548 5.84518 11.875 5.5 11.875C5.15482 11.875 4.875 12.1548 4.875 12.5C4.875 12.8452 5.15482 13.125 5.5 13.125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.311c5ba4d02beec373a9e0bdd18ab47a.svg";
export { ForwardRef as ReactComponent };